export default __webpack_public_path__ + "static/media/excipient.56f65678.svg";